<template>
  <div class="app-container">
    <el-card class="box-card">
      <folded-panel infoName="基本信息">
        <div slot="content">
          <dynamic-form
            labelWidth="120px"
            :formConfig="formConfig"
            v-model="form"
            :disabled="!isEdit"
            :showBtn="false"
            ref="form"
          />
        </div>
      </folded-panel>
      <data-box
        v-if="!id"
        hostUrl="/bs-project-milestone"
        :props="{label: 'name',value: 'id'}"
        :tableColumn="dataBoxHead"
        :multiple="false"
        :extendParms="{ foundNumber:form.projectType}"
        :trigger="{btnType:'button',title:'导入模板'}"
        v-model="importArr"
        @confirm="(val) => mbimport(val)"
      ></data-box>
      <folded-panel infoName="项目阶段">
        <div slot="content">
          <edit-data-table
            v-if="doLayout"
            :head="tableHead3"
            :data.sync="tableData3"
            :config="{trigger: 'click', mode: 'cell',autoClearActive:false}"
            :edit-rules="validRules"
            :editable="isEdit"
            :showAdd="isEdit"
            max-height="500px"
            show-summary
            :summary-method="summaryMethod"
            ref="projectStage"
          >
            <template #code="{$index}">
              <span>{{$index+1}}</span>
            </template>
            <template #bsMilestoneNode="{row}">
              <span>{{row.bsMilestoneNode? row.bsMilestoneNode.name:''}}</span>
            </template>
            <template #bsMilestoneNodeEdit="{row}">
              <data-box
                hostUrl="/bsMilestoneNode"
                :props="{label: 'name',value: 'id'}"
                :tableColumn="dataBoxHead"
                :multiple="false"
                v-model="row.bsMilestoneNode"
                @confirm="(val) => {row.milestoneNode = val.id}"
              ></data-box>
            </template>
            <template #receipt="{row}">
              <span>{{row.receipt ? row.receipt.label: ""}}</span>
            </template>
            <template #receiptEdit="{row}">
              <data-box
                :props="{label: 'label',value: 'id'}"
                :tableColumn="receiptHead"
                :tableData="paymentDetails"
                :multiple="false"
                v-model="row.receipt"
                @confirm="(val) => {row.receiptId = val.id}"
              ></data-box>
            </template>
            <template #isEnabled="{row}">
              <span v-if="row.actualCompletionTime == null">
                <el-tag v-if="!row.isEnabled">未开启</el-tag>
                <el-tag type="success" v-if="row.isEnabled === 1">已开启</el-tag>
                <el-tag type="info" v-if="row.isEnabled === 2">已关闭</el-tag>
                <el-button size="mini" type="success" v-if="(isProjectManager) && (row.isEnabled === 0)" @click="startMilestone(row)">开启</el-button>
                <el-button size="mini" type="info" v-if="(isProjectManager) && row.isEnabled === 1" @click="closeMilestone(row)">关闭</el-button>
                <el-button size="mini" type="warning" v-if="(isProjectManager)" @click="resetMilestone(row)">重置</el-button>
              </span>
              <span v-else><el-tag type="info">已关闭</el-tag></span>
            </template>
             <template #actualCost="{row}">
              <el-tag type="warning" v-if="row.yellow >= 70 && row.yellow < 90 ">{{row.actualCost}}</el-tag>
              <el-tag type="danger" v-else-if="row.yellow >= 90">{{row.actualCost}}</el-tag>
              <span v-else>{{row.actualCost}}</span>
            </template>
            <template #latestFinishTime="{row}">
              <span v-if="row.actualCompletionTime !== null">{{row.latestFinishTime}}</span>
              <el-tag type="warning" v-else-if="row.differNumber >= 70 && row.differNumber < 90 ">{{row.latestFinishTime}}</el-tag>
              <el-tag type="danger" v-else-if="row.differNumber >= 90">{{row.latestFinishTime}}</el-tag>
              <span v-else>{{row.latestFinishTime}}</span>
            </template>
            <template #actualCompletionTime="{row}">
              <span v-if="row.actualCompletionTime == null">
                <el-popover :ref="row.$index + 'a'" placement="top" width="180" v-if="form.billState === 3 && row.isFinish !== 1 && row.isEnabled == 1">
                  <p>该阶段任务确定已完成吗？</p>
                  <div style="text-align: right; margin: 0">
                    <el-button size="mini" type="text" @click="$refs[row.$index + 'a'].doClose()">取消</el-button>
                    <el-button type="primary" size="mini" @click="finishTask(row)">确定 </el-button>
                  </div>
                  <el-button v-if="(isMileStoneOper || isMaintainProject)" type="text" size="mini" icon="el-icon-circle-check" slot="reference"></el-button>
                </el-popover>
              </span>
              <span v-else>{{row.actualCompletionTime}}</span>
            </template>
            <template #keyOutsList="{row}">
              <span v-for="(item, index) in row.keyOutsList" :key="item.id">{{item.name}}{{index &lt; row.keyOutsList.length-1 ? ',' : ''}}</span>
            </template>
            <template #keyOutsListEdit="{row}">
              <data-box
                hostUrl="/bsKeyOuts"
                :props="{label: 'name',value: 'id'}"
                :tableColumn="dataBoxHead"
                :multiple="true"
                v-model="row.keyOutsListArr"
                @confirm="(val) => {row.keyOutsList = val;const newArr = val.map((item) => { return item.id });row.keyOutput = newArr.join()? newArr.join():null}"
              ></data-box>
            </template>
            <template #toolbar="scope">
               <el-popover :ref="scope.$index + 'a'" placement="top" width="180" v-if="isEdit">
                <p>确定删除本条数据吗？</p>
                <div style="text-align: right; margin: 0">
                  <el-button size="mini" type="text" @click="$refs[scope.$index + 'a'].doClose()">取消</el-button>
                  <el-button type="primary" size="mini" @click="delMilestonePlans(scope.row.id,scope)">确定</el-button>
                </div>
                <el-button type="text" size="mini" icon="el-icon-delete" slot="reference"></el-button>
              </el-popover>
              <template v-if="scope.row.id && !isEdit">
                <el-button type="text" size="mini" @click="changeApply(scope.row)" v-if="scope.row.isFinish !== 1">变更申请</el-button>
                <el-button type="text" size="mini" @click="changeApplyHis(scope.row)" >变更历史</el-button>
              </template>
            </template>
          </edit-data-table>
        </div>
      </folded-panel>
      <folded-panel infoName="费用明细">
        <div slot="content">
          <edit-data-table
            :head="tableHead2"
            :data.sync="tableData2"
            :config="{trigger: 'click', mode: 'cell',autoClearActive:false}"
            :edit-rules="costRules"
            :editable="isEdit"
            :showAdd="isEdit"
            max-height="400px"
            ref="expense"
          >
            <template #bsProjectBudget="{row}">
              <span>{{row.bsProjectBudget? row.bsProjectBudget.name:''}}</span>
            </template>
            <template #bsProjectBudgetEdit="{row}">
              <data-box
                hostUrl="/bsProjectBudget"
                :props="{label: 'name',value: 'id'}"
                :tableColumn="dataBoxHead"
                :multiple="false"
                v-model="row.bsProjectBudget"
                @confirm="(val) => {row.budgetItem = val.id}"
              ></data-box>
            </template>
            <template #toolbar="scope">
              <span v-if="!isEdit">无</span>
               <el-popover :ref="scope.$index + 'b'" placement="top" width="180" v-if="isEdit">
                <p>确定删除本条数据吗？</p>
                <div style="text-align: right; margin: 0">
                  <el-button size="mini" type="text" @click="$refs[scope.$index + 'b'].doClose()">取消</el-button>
                  <el-button
                    type="primary"
                    size="mini"
                    @click="delChargeDetails(scope.row.id,scope)">确定
                  </el-button>
                </div>
                <el-button type="text" size="mini" icon="el-icon-delete" slot="reference"></el-button>
              </el-popover>
            </template>
          </edit-data-table>
        </div>
      </folded-panel>
      <folded-panel infoName="可支配人员">
        <div slot="content">
          <edit-data-table
            :head="tableHead4"
            :data.sync="tableData4"
            :config="{trigger: 'click', mode: 'cell',autoClearActive:false}"
            :edit-rules="tableHead4Rules"
            :editable="isEdit"
            :showAdd="isEdit"
            max-height="400px"
            ref="person"
          >
            <template #person="{row}">
              <span>{{row.person? row.person.name:''}}</span>
            </template>
            <template #personEdit="{row}">
              <data-box
                hostUrl="/bs-person/getList"
                :props="{label: 'name',value: 'id'}"
                :tableColumn="dataBoxHead"
                :multiple="false"
                v-model="row.person"
                @confirm="(val) => {row.staff = val.id;row.settlementPrice = val.rankEntity.settlementUnitPrice || 0}"
              ></data-box>
            </template>
             <template #projectRoles="{row}">
              <span>{{row.projectRoles? row.projectRoles.name:''}}</span>
            </template>
            <template #projectRolesEdit="{row}">
              <data-box
                hostUrl="/bsProjectRoles"
                :props="{label: 'name',value: 'id'}"
                :tableColumn="dataBoxHead"
                :multiple="false"
                v-model="row.projectRoles"
                 @confirm="(val) => {row.projectRole = val.id}"
              ></data-box>
            </template>
            <template #releaseStatusEdit="{row}">
              <span>{{row.releaseStatus == 1? '借用':'占用'}}</span>
            </template>
            <template #toolbar="scope">
              <span v-if="!isEdit">无</span>
              <el-popover :ref="scope.$index + 'c'" placement="top" width="180" v-if="isEdit">
                <p>确定删除本条数据吗？</p>
                <div style="text-align: right; margin: 0">
                  <el-button size="mini" type="text" @click="$refs[scope.$index + 'c'].doClose()">取消</el-button>
                  <el-button type="primary" size="mini" @click="delDisposablePeople(scope.row.id,scope)">确定</el-button>
                </div>
                <el-button type="text" size="mini" icon="el-icon-delete" slot="reference"></el-button>
              </el-popover>
            </template>
          </edit-data-table>
        </div>
      </folded-panel>
       <folded-panel infoName="收款明细">
        <div slot="content">
          <edit-data-table
            :head="paymentDetailHead"
            :data.sync="paymentDetails"
            :config="{trigger: 'click', mode: 'cell'}"
            :editable="false"
            :showAdd="false"
            :toolBar="{ hidden: true}"
            max-height="400px"
          >
           <template #moneyId="{row}">
              <div v-for="item in receiptTypes" :key="item.id">
                <div v-if="row.moneyId && row.moneyId.toString() === item.value">{{item.label}}</div>
              </div>
            </template>
          </edit-data-table>
        </div>
      </folded-panel>
      <folded-panel infoName="预算详细清单">
        <div slot="content">
          <el-upload
            v-if="isEdit"
            class="upload-demo"
            :action="actionUrl"
            :headers="uploadHeaders"
            :on-success="handleSuccess"
            :file-list="fileId"
            :show-file-list="true"
            :on-remove="handleRemove"
            :before-remove="beforeRemove"
            :on-preview="preview"
            style="margin: 14px"
          >
            <el-button size="small" type="primary">预算详细清单上传</el-button>
          </el-upload>
          <div class="file-box" v-if="!isEdit">
            <div v-for="item in fileId" :key="item.id" class="file-item">
              <el-button @click="preview(item)">{{ item.name }}</el-button>
              <!-- <i class="el-icon-close file-close" v-if="isEdit" @click="delFile(item,index)"></i> -->
            </div>
          </div>
        </div>
      </folded-panel>
      <div class="button">
        <el-button class="btn-cancel" v-if="isEdit" :loading="loading" @click="save(1)">保存</el-button>
        <!-- <el-button class="btn-submit btn-submit-file" v-if="isEdit" :loading="loading" @click="submitFile" :disabled="getInitFileState(form)" :class="{ 'isSubmit': getInitFileState(form) }">提交附件</el-button> -->
        <el-button class="btn-submit" v-if="isEdit" :loading="loading" @click="submit(2)">提交</el-button>
        <el-button class="btn-cancel" @click="cancel">取消</el-button>
      </div>
      <drag-dialog :show="stepShow" :title="'审批人选择'" :width="'40%'" @close="close">
        <PersonStep :data="personStepData" @submit="submitConfirm" @close="close"></PersonStep>
      </drag-dialog>
      <drag-dialog :show="stepShowFile" :title="'审批人选择'" :width="'40%'" @close="close">
        <PersonStep :data="personStepDataFile" @submit="submitConfirmFile" @close="closeFile"></PersonStep>
      </drag-dialog>

      <drag-dialog
        append-to-body
        :show.sync="changeApplyVisible"
        title="阶段变更申请"
        :enableDrag="true"
        width="800px"
        @close="changeApplyVisible = false"
      >
        <dynamic-form
          :formConfig="applyFormConfig"
          v-model="applyForm"
          labelWidth="120px"
          @submit="applyFormSubmit"
          @cancelForm="changeApplyVisible = false"
          ref="pageForm"
        ></dynamic-form>
      </drag-dialog>

      <drag-dialog
        append-to-body
        :show.sync="changeApplyHisVisible"
        title="阶段变更历史"
        :enableDrag="true"
        width="1024px"
        @close="changeApplyHisVisible = false"
      >
        <edit-data-table
        :head="applyHisHead"
        :data.sync="list"
        :config="{trigger: 'click', mode: 'cell'}"
        :total="total"
        :offset="offset"
        :page="page"
        :loading="loading"
        border
        :editable="false"
        :showAdd="false"
        stripe
        :toolBar="{hidden: true}"
      >
        <template #changeType="{row}">
          <div v-for="item in changeTypeStatus" :key="item.id">
            <div v-if="row.changeType.toString() === item.value">{{item.label}}</div>
          </div>
        </template>
        <template #status="{row}">
          <el-tag v-if="row.status === 0">未审批</el-tag>
          <el-tag v-if="row.status === 1" type="success">已通过</el-tag>
          <el-tag v-if="row.status === 2" type="danger">未通过</el-tag>
        </template>
      </edit-data-table>
      </drag-dialog>
    </el-card>
  </div>
</template>

<script>
import FoldedPanel from "@/components/FoldedPanel";
import "@/components/dynamic-form";
import "@/components/EditDataTable";
import DataBox from "@/components/dynamic-form/dynamic-data-box";
import { parseTime } from "@/utils";
import initDict from "@/mixin/initDict";
import { tableSataus } from "@/views/bill/mixins/status";
import CrudMixin from "@/mixins/CrudMixin";
import {findContractById, downLoad, delFile} from "@/api/bill/contract";
import { addMilestonePlanChange} from '@/api/bill/milestonePlanChange'
import { toThousandFilter } from '@/filters'
import {
  getProjectDelivery,
  addProjectDelivery,
  delLaborCosts,
  delChargeDetails,
  delMilestonePlans,
  delBonusPlans,
  delBonuses,
  delDisposablePeople,deliveryIsFinish,
  deliveryMilestoneStatus,
  submitFile
} from "@/api/basic";
import { idQuery } from "@/api/basic/projectPhase";
import { getDocumentCode } from "@/views/utils";
import DragDialog from "@/components/DragDialog"
import { getFlowNode } from "@/api/hrApproval"
import PersonStep from "@/components/PersonStep";
import DataTableMixin from "@/mixins/DataTableMixin";
import { getToken } from "@/utils/auth";
import { getDeptAndChildrenTree } from "@/api/dept";
import { deepClone } from "@/utils/index";
export default {
  name: "DeliveryForm",
  components: {
    FoldedPanel,
    DataBox,DragDialog,PersonStep
  },
  mixins: [initDict, DataTableMixin, tableSataus,CrudMixin],
  data() {
    return {
      isDisabled: true,
      actionUrl: `${process.env.VUE_APP_BASE_API}/attachment/masterdata/fileUpload`,
      uploadHeaders: {},
      fileId: [],
      isMaintainProject: false,
      daoru: false,
      isEdit: true,
      changeApplyVisible: false,  // 弹出变更申请
      changeApplyHisVisible: false, // 弹出历史列表
      loading: false,
      dialogShow: false, // 提交弹窗
      applyForm: {},
      applyHisHead: [
        {
          label: '申请时间',
          prop: "created"
        },
        {
          label: '申请人',
          prop: "creatorName"
        },
        {
          label: "调整类型",
          prop: "changeType"
        },
        {
          label: "预计开始时间",
          prop: "expectedStartTime"
        },
        {
          label: "预计完成时间",
          prop: "latestFinishTime"
        },
        {
          label: "调整计划开始时间",
          prop: "changeStartTime"
        },
        {
          label: "调整计划完成时间",
          prop: "changeFinishTime"
        },
        {
          label: "调整原因",
          prop: "reason"
        },
        {
          label: "审批状态",
          prop: "status"
        }
      ],
      applyFormConfig: {
        formItemList: [
          {
            label: '项目号',
            key: 'projectNumber',
            type: 'input',
            span: 12,
            disabled: true
          },
          {
            label: '项目名',
            key: 'projectName',
            type: 'input',
            span: 12,
            disabled: true
          },
          {
            label: '项目阶段名称',
            key: 'milestoneName',
            type: 'input',
            span: 12,
            disabled: true
          },
          {
            type: "select",
            label: "调整类型",
            key: "changeType",
            span: 12,
            options: [],
            rules: [{
              required: true,
              message: "不能为空",
              trigger: "change"
            }]
          },
          {
            span: 12,
            label: '原计划开始日期',
            key: 'expectedStartTime',
            type: 'date',
            disabled: true
          },
          {
            span: 12,
            label: '原计划完成日期',
            key: 'latestFinishTime',
            type: 'date',
            disabled: true
          },
          {
            span: 12,
            label: '调整开始日期',
            key: 'changeStartTime',
            type: 'date',
            disabled: false
          },
          {
            span: 12,
            label: '调整完成日期',
            key: 'changeFinishTime',
            type: 'date',
            disabled: false
          },
          {
            span: 24,
            type: "input",
            key: "reason",
            label: "调整原因",
            subtype: 'textarea',
            placeholder: "请输入调整原因",
            disabled: false
          }
        ]
      },
      keyOutsListArr: [],
      importArr: [],
      contractIds: "",
      tableData: [],
      tableData1: [],
      formConfig: {
        formItemList: [
          {
            type: "input",
            key: "code",
            label: "单据编号",
            value: "",
            placeholder: "请输入标题",
            span: 8,
            disabled: true
          },
          {
            label: "项目名",
            key: "projectObj",
            type: "databox",
            span: 8,
            props: {
              label: "name",
              value: "code"
            },
            url: "/bsProject",
            tableColumn: [
              {
                property: "code",
                label: "项目号"
              },
              {
                property: "name",
                label: "名称",
                query: {
                  type: "input"
                }
              }
            ],
            events: {
              change: (val) => {
                console.log(val)
                if (val.customer) {
                  this.form.customerMain = val.customer.name || ''
                }
                if (val) {
                  this.form.subContractAmount = val.subContractAmount || ''
                }
              }
            },
            extendParms: { searchType: 1 },
            multiple: false,
            rules: [{
              required: true,
              message: "不能为空",
              trigger: "change",
            }]
          },
          {
            label: "项目号",
            key: "projectNumber",
            type: "input",
            span: 8,
            disabled: true
          },
          {
            label: "子项目合同金额",
            key: "subContractAmount",
            type: "input",
            span: 8,
            disabled: true
          },
          /* {
            type: "select",
            label: "立项类型",
            key: "projectType",
            span: 8,
            options: [],
            rules: [{
              required: true,
              message: "不能为空",
              trigger: "change"
            }]
          }, */
          {
            label: "合同",
            key: "contract",
            type: "databox",
            span: 8,
            props: {
              label: "name",
              value: "id"
            },
            disabled: true,
            url: "/bizContract",
            tableColumn: [
              {
                property: "code",
                label: "编码"
              },
              {
                property: "name",
                label: "名称",
                query: {
                  type: "input"
                }
              }
            ],
            extendParms: {billState: 3},
            multiple: false,
            rules: [{
              required: true,
              message: "不能为空",
              trigger: "change"
            }]
          },
          {
            type: "input",
            label: "业务集团",
            key: "departmentId",
            clearable: true,
            filterable: true,
            disabled: true,
            span: 8,
          },
          {
            label: "项目经理",
            key: "projectManagerObj",
            type: "databox",
            span: 8,
            props: {
              label: "name",
              value: "id"
            },
            disabled: true,
            url: "/bs-person/getList",
            tableColumn: [
              {
                property: "code",
                label: "编码",
              },
              {
                property: "name",
                label: "名称",
                query: {
                  type: "input"
                }
              }
            ],
            extendParms: { queryFieldItem: "id,code,name" },
            multiple: false,
            rules: [{
              required: true,
              message: "不能为空",
              trigger: "change"
            }]
          },
          {
            type: "number",
            key: "costBudgeting",
            label: "交付成本",
            value: "",
            disabled: true,
            span: 8,
             rules: [{
              required: true,
              message: "不能为空",
              trigger: "blur"
            }]
          },
          {
            type: "number",
            key: "costForecast",
            label: "人工成本预算",
            value: "",
            placeholder: "请输入数值",
            span: 8,
            disabled: true
          },
          {
            type: "number",
            key: "costBalance",
            label: "人工成本结余",
            value: "",
            disabled: true,
            span: 8
          },
          {
            type: "number",
            key: "budget",
            label: "费用预算",
            value: "",
            disabled: true,
            span: 8,
            rules: [{
              required: true,
              message: "不能为空",
              trigger: "change"
            }]
          },
          {
            type: "number",
            key: "budgetBalance",
            label: "费用预算结余",
            value: "",
            disabled: true,
            span: 8
          },
          {
            type: "number",
            key: "riskFundTotal",
            label: "风险金预算",
            value: "",
            disabled: true,
            span: 8,
             rules: [{
              required: true,
              message: "不能为空",
              trigger: "blur"
            }]
          },
          {
            type: "number",
            key: "riskFundBalance",
            label: "风险金结余",
            value: "",
            disabled: true,
            span: 8
          },
          /*  {
            type: "number",
            key: "targetCost",
            label: "人工目标成本",
            value: "",
            span: 8,
             rules: [{
              required: true,
              message: "不能为空",
              trigger: "blur"
            }]
          }, */
          /* {
            span: 8,
            key: "planCloseTime",
            value: null,
            placeholder: "请选择",
            type: "date",
            label: "计划结项日期",
            valueFormat: "yyyy-MM-dd",
            rules: [{
              required: true,
              message: "不能为空",
              trigger: "blur"
            }]
          }, */
           {
            span: 8,
            key: "created",
            value: null,
            placeholder: "请选择",
            type: "date",
            label: "创建日期",
            valueFormat: "yyyy-MM-dd",
            disabled: true
          },
          /* {
            type: "number",
            key: "collectMoney",
            label: "收款金额",
            value: "",
            disabled: true,
            span: 8
          }, */
          {
            type: "input",
            key: "customerMain",
            label: "终端客户",
            disabled: true,
            value: "",
            span: 8
          },
          {
            span: 8,
            key: "checkDate",
            value: null,
            placeholder: "请选择",
            type: "date",
            label: "验收日期",
            valueFormat: "yyyy-MM-dd",
            disabled: true
            /* rules: [{
              required: true,
              message: "不能为空",
              trigger: "blur"
            }] */
          },
          /* {
            span: 8,
            key: "maintenanceDate",
            value: null,
            placeholder: "请选择",
            type: "date",
            label: "维保日期",
            valueFormat: "yyyy-MM-dd",
            disabled: true
          }, */
          {
            span: 8,
            label: '维保时间',
            key: 'maintenanceDate',
            value: null,
            type: 'date',
            subtype: 'daterange',
            valueFormat: "yyyy-MM-dd",
            disabled: true,
            'start-placeholder': "开始日期",
            'end-placeholder': "结束日期"
          },
          {
            type: "textarea",
            key: "remark",
            label: "备注",
            value: "",
            span: 24,
            maxlength: 200,
          },
          /* {
            type: "input",
            key: "riskFundPercent",
            label: "风险金比例",
            value: "",
            disabled: true,
            span: 8
          }, */
          /* {
            type: "input",
            key: "costPercent",
            label: "交付成本比例",
            value: "",
            disabled: true,
            span: 8
          }, */
        ]
      },
      form: {
        costBalance: '',
        costForecast: '',
        riskFundBalance: ''
      },
      tableHead2: [
        {
          label: "预算项目",
          prop: "bsProjectBudget",
          editRender: { type: "default", name: "ElInput" }
        },
        {
          label: "预算金额",
          prop: "budgetAmount",
          editRender: { type: "default",name: "ElInput", props: { placeholder: "请输入数值" } }
        },
        {
          label: "耗费金额",
          prop: "amountSpent"
        },
        {
          label: "结余金额",
          prop: "balance",
          formatter: (val, row) => {
            return this.$numberUtils.sub(row.budgetAmount, row.amountSpent);
          }
        },
        {
          label: "备注",
          prop: "remark",
          editRender: { type: "default", name: "ElInput" }
        }
      ],
      tableHead3: [
        {
          label: "序号",
          prop: "code",
          width: '70',
        },
        {
          label: "阶段状态",
          prop: "isEnabled",
          width: '210px'
        },
        {
          label: "项目阶段",
          prop: "bsMilestoneNode",
          width: '180px',
          editRender: { type: "default" }
        },
        {
          label: "阶段描述",
          prop: "remark",
          width: '180px',
          editRender: { type: "default", name: "ElInput" }
        },
        /* {
          label: "款项说明",
          prop: "receipt",
           width: '120px',
          editRender: {  type: "default",}
        }, */
        {
          label: "计划开始时间",
          prop: "expectedStartTime",
          width: '140px',
          editRender: {
            name: "ElDatePicker",
            props: { type: "date", valueFormat: "yyyy-MM-dd" }
          }
        },
        {
          label: "最新变更开始时间",
          prop: "planChangeStartTime",
          width: '140px'
        },
        {
          label: "计划完成时间",
          prop: "latestFinishTime",
          width: '140px',
          editRender: {
            name: "ElDatePicker",
            props: {type: "date", valueFormat: "yyyy-MM-dd",}
          }
        },
        {
          label: "最新变更结束时间",
          prop: "planChangeEndTime",
          width: '140px',
        },
        //  {
        //   label: "是否完成",
        //   prop: "isFinish",
        //   editRender: { type: "default", name: "ElInput", props: {disabled: true }},
        //   formatter: (val, row) => {
        //     return val === 1 ? '已完成' : '未完成'
        //   }
        // },
        {
          label: "实际完成时间",
          prop: "actualCompletionTime",
          width: '140px'
        },
        /* {
          label: "阶段完成操作人",
          prop: "operFinishPerson",
          width: '140px'
        }, */
        /* {
          label: "收入",
          prop: "gain",
          width: '120px',
          editRender: { type: "default", name: "ElInputNumber", props: {controls: false} }
        }, */
         {
          label: "预计消耗成本",
          prop: "planCost",
           width: '140px',
          editRender: { type: "default", name: "ElInput", }
        },
        {
          label: "已分配成本",
          prop: "verifyAmount",
          width: '140px',
        },
        {
          label: "已汇报成本",
          prop: "actualAmount",
          width: '140px',
        },
        {
          label: "实际消耗成本",
          prop: "actualCost",
          width: '140px',
        },
         {
          label: "风险金",
          prop: "riskFund",
          width: '100px',
        },
        /* {
          label: "风险金占比",
          prop: "riskPercent",
          width: '140px',
        }, */
        {
          label: "关键输出物",
          prop: "keyOutsList",
          width: '120px',
          editRender: { type: "default" }
        },
        {
          label: "阶段操作时间",
          prop: "operTime",
          width: '140px'
        },
        /* {
          label: "阶段状态操作人",
          prop: "operPerson",
          width: '140px'
        } */
      ],
      tableHead4: [
        {
          label: "人员",
          prop: "person",
          editRender: { type: "default", }
        },
        /* {
          label: "结算单价",
          prop: "settlementPrice"
        }, */
        {
          label: "项目角色",
          prop: "projectRoles",
          editRender: { type: "default",}
        },
        // {
        //   label: "总占用天数",
        //   prop: "applyDay",
        //   editRender: { type: "default", name: "ElInput" }
        // },
        //  {
        //   label: "剩余天数",
        //   prop: "applyDaysRemainig",
        //   editRender: { type: "default", name: "ElInput" }
        // },
         {
          label: "实际消耗人天",
          prop: "projectConsumption",
          formatter: (val,row) => {
            if (val && val !== null && val !== '') {
              return val;
            } else {
              return '0';
            }
          }
        },
        /*   {
          label: "实际耗费成本",
          prop: "projectCost",
          formatter: (val,row) => {
            if (val && val !== null && val !== '') {
              return val;
            } else {
              return '0';
            }
          }
          // formatter: (val, row) => {
          //   return (
          //     parseInt(row.settlementPrice) *
          //       parseInt(row.projectConsumption) || ""
          //   );
          // }
        }, */
        /* {
          label: "是否是借用",
          prop: "releaseStatus",
           formatter: (val, row) => {
            return val === 1 ? '借用' : '占用'
          }
        }, */
      ],
      tableData2: [],
      tableData3: [],
      tableData4: [],
      tableData5: [],
      tableData6: [],
      dataBoxHead: [
        { label: "编码", property: "code" },
        { label: "名称", property: "name", query: { type: "input" } },
        { label: "备注", property: "remark" }
      ],
      projectCostSum: 0, // 项目耗费成本总和
      validRules: {
        bsMilestoneNode: [{ required: true, message: "不能为空", trigger: "blur" }],
        receipt: [{ required: true, message: "不能为空", trigger: "blur" }],
        workTargetDetail: [{ required: true, message: "不能为空", trigger: "blur" }],
        expectedStartTime: [{ required: true, message: "不能为空", trigger: "blur" }],
        latestFinishTime: [{ required: true, message: "不能为空", trigger: "blur" }],
        planCost: [{ required: true, message: "不能为空", trigger: "blur" }]
      },
      costRules: {
        bsProjectBudget: [{ required: true, message: "不能为空", trigger: "blur" }],
        budgetAmount: [{ required: true, message: "不能为空", trigger: "blur" ,type: 'number'},
         {
            validator(rule, value, callback) {
              const reg = /^\d+\.?(\d{1,2})?$/
              if (reg.test(value)) {
                callback();
              } else {
                callback(new Error("小数点后保留两位"));
              }
            },
            trigger: "change"
          }]
      },
      tableHead4Rules: {
        projectRoles: [{ required: true, message: "不能为空", trigger: "blur" }],
        person: [{ required: true, message: "不能为空", trigger: "blur" }]
      },
      validateRefNames: ['form', 'projectStage', 'expense'],
      form2: {}, // hr审批
      assignData: {},// hr审批人员信息
      paymentDetailHead: [
          /* {
            label: "款项说明",
            prop: "moneyId",
          }, */
          {
            label: "金额",
            prop: "totals",
          },
          {
            label: "已收金额",
            prop: "receivedMoney",
          },
          {
            label: "未收金额",
            prop: "uncollectedMoney",
            formatter: (val, row) => {
              const value = parseInt(row.totals) - parseInt(row.receivedMoney ? row.receivedMoney : 0);
              row.uncollectedMoney = value;
              return value || ''
            }
          },
          {
            label: "付款条件",
            prop: "conditions",
          },
          {
            label: "备注",
            prop: "remark",
          }
        ],
        paymentDetails: [],
        contractDetailId: '',
        receiptTypes: [], // 收款方式
        changeTypeStatus: [],
        stepShow: false,
        personStepData: [],
        stepShowFile: false,
        personStepDataFile: [],
        contractId2: '',
        riskSum: 0,
        receiptHead: [
          /* { label: "款项说明", property: "label", }, */
          { label: "金额", property: "totals"},
          { label: "已收金额", property: "receivedMoney" },
          { label: "未收金额", property: "uncollectedMoney" }
        ],
        doLayout: true,
        OldFileList: []
    };
  },
  watch: {
    "form.projectObj": {
      immediate: false,
      handler(val) {
        if (val) {
          console.log(val)
          this.form.projectNumber = val.code;
          if (val.contract) {
            this.form.contract = { id: val.contractId, name: val.contract.name }
          }
          if (val.personManager) {
            this.form.projectManagerObj = { id: val.projectManageId, name: val.personManager.name };
          }
          if (val.businessGroup) {
            this.form.departmentId = val.businessGroup
          }
          if (val.maintainStartDate && val.maintainEndDate) {
            this.form.maintenanceDate = [val.maintainStartDate, val.maintainEndDate]
          }
          if (val.checkDate) {
            this.form.checkDate = val.checkDate
          }
        }
      },
    },
    'form.contract': {
      handler(val,oldVal) {
        if (val && val !== oldVal) {
          const id = this.contractDetailId ? this.contractDetailId : val.id
          this.contractId2 = val.id
          findContractById(id).then(res => {
            this.paymentDetails = res.data.bizPaymentDetails
            if (this.paymentDetails.length <= 0) {
                // this.form.collectMoney = 0
            } else {
              //  this.form.collectMoney = 0
              // for (const i of this.paymentDetails) {
              // this.form.collectMoney += (parseInt(i.receivedMoney || 0))
              // }
            }
          })
        }
      },
      deep: true
    },
    /* 'form.projectType': {
      handler(val,oldVal) {
        if (val && val !== oldVal) {
          const idx = this.formConfig.formItemList.findIndex(i => i.key === 'projectManagerObj')
          if (idx !== -1) {
            let label = '项目经理'
            // 售前项目
            if (val === 'SQXM') {
              label = '销售负责人'
            }
            this.$set(this.formConfig.formItemList[idx], 'label', label)
          }
        }
      },
      immediate: true
    }, */
    tableData2: {
      handler(val,oldVal) {
        if (val.length <= 0) {
          this.form.budget = 0
          this.form.budgetBalance = 0
        } else {
          this.form.budget = 0
          this.form.budgetBalance = 0
        for (const i of val) {
        this.form.budget += (parseInt(i.budgetAmount) || 0); // 计算费用预算
        this.form.budgetBalance += (parseInt(i.budgetAmount) || 0) - (parseInt(i.amountSpent) || 0);
        // i.balance = parseInt(i.budgetAmount) - parseInt(i.amountSpent) || i.budgetAmount; // 结余金额
        }
        // 交付成本自动计算=人工成本预算+风险金+费用预算
        this.form.costBudgeting = Number((Number(this.form.costForecast || 0) + Number(this.form.riskFundTotal || 0) + Number(this.form.budget || 0)).toFixed(2))
      }
      },
      deep: true
    },
    tableData3: {
      handler(val,oldVal) {
        this.riskSum = 0
        let planCostSum = 0.00
        let actualCostSum = 0.00
        val.forEach((item,index) => {
          planCostSum = Number((planCostSum + Number(item.planCost || 0)).toFixed(2))
          actualCostSum = Number((actualCostSum + Number(item.actualCost || 0)).toFixed(2))
          item.code = index + 1
          item.yellow = (parseInt((item.actualCost) || 0) / parseInt((item.planCost) || 0)) * 100
          if (item.expectedStartTime) {
            if (item.latestFinishTime) {
              item.planNumber = this.getEndDate(parseTime(item.expectedStartTime, "{y}-{m}-{d}"),parseTime(item.latestFinishTime, "{y}-{m}-{d}")) + 1
            }
            item.nowNumber = this.getEndDate(parseTime(item.expectedStartTime, "{y}-{m}-{d}"),parseTime(new Date(), "{y}-{m}-{d}")) + 1
          }
          item.differNumber = (parseInt(item.nowNumber) / parseInt(item.planNumber)) *  100
           this.riskSum += parseInt(item.riskFund)
          // 风险金结余= 风险金预算-风险金之和
          // this.form.riskFundBalance = parseInt(this.form.riskFundTotal) - (parseInt(this.riskSum) || 0)
        })
        console.log('<><><><><><>>><><><><><><><><><><><>', planCostSum)
        this.form.costForecast = planCostSum // 人工成本预算
        // if  (this.tableData4.length <= 0) { // 人工成本结余
        //   this.form.costBalance = this.$numberUtils.sub(this.form.costForecast, planCostSum, 0) || 0
        // }
        this.form.costBalance = this.$numberUtils.sub(this.form.actualCostSum, planCostSum, 0) || 0
        this.form.riskFundTotal = Number((Number(this.form.costForecast || 0) * 0.1).toFixed(2)) // 风险金预算
        // 交付成本自动计算=人工成本预算+风险金+费用预算
        this.form.costBudgeting = Number((Number(this.form.costForecast || 0) + Number(this.form.riskFundTotal || 0) + Number(this.form.budget || 0)).toFixed(2))
        // 风险金结余= 风险金预算-风险金之和
        this.form.riskFundBalance = parseInt(this.form.riskFundTotal) - (parseInt(this.riskSum) || 0)
      },
      deep: true
    },
    tableData4: {
      handler(val,oldVal) {
        console.log('tableData3tableData3tableData3tableData3tableData3tableData3', this.tableData3)
        if (val.length <= 0) {
          this.form.costBalance = parseInt(this.form.costForecast)
        } else {
          this.form.costBalance = 0;
          this.projectCostSum = 0;
          // for (const i of val) {
          //   this.projectCostSum += parseInt(i.projectCost || 0);
          //   // 人工成本结余= 人工成本预算-项目耗费成本之和
          //   this.form.costBalance =  this.$numberUtils.sub(this.form.costForecast, this.projectCostSum, 0) || 0
          // }
          let actualCostSum = 0.00
          this.tableData3.forEach(item => {
            actualCostSum = Number((actualCostSum + Number(item.actualCost || 0)).toFixed(2))
          })
          this.form.costBalance = this.$numberUtils.sub(this.form.costForecast, actualCostSum, 0) || 0
        }
      },
      deep: true
    }
  },
  created() {
    const url = '/bsProject?personSaleId=' + this.$store.state.user.user.personId
    this.$set(this.formConfig.formItemList[this.formConfig.formItemList.findIndex(item => item.key === 'projectObj')], 'url', url)
    this.uploadHeaders = { Authorization: `Bearer ${getToken()}` };
    this.id = this.$route.params.id;
    this.isEdit = this.$route.params.isEdit !== undefined ? Boolean(Number(this.$route.params.isEdit)) : true;
    this.getDeptTreeInterface(); // 获取部门
    if (this.id) {
      getProjectDelivery(this.id).then(res => {
        const form = res.data.projectDelivery;
        this.tableData4 = res.data.disposablePersonList;
        if (form.projectNumber && form.projectName) {
          form.projectObj = { code: form.projectNumber, name: form.projectName };
        }
        // form.operatorObj = form.person;
        // form.projectLeader = { id: form.projectLeader, name: form.leader };
        form.projectManagerObj = form.personManager;
        // form.cNumber = {code: form.cnumber ,name: form.cnumber,}
        if (form.contractDelivery) {
          form.contract = {
            code: form.contractDelivery.contractCode,
            id: form.contractDelivery.contractId,
            name: form.contractDelivery.contractName,
            totals: form.contractDelivery.totals
          }
          this.contractIds = form.contractDelivery.id
          this.contractDetailId = form.contractDelivery.contractId
        }
        // form.collectMoney = ''
        if (form.bsProject && form.bsProject.customer) {
          form.customerMain = form.bsProject.customer.name || ''
        }
            // 判断立项类型是运维项目
        /* if (form.projectType === 'YWXM') {
          this.isMaintainProject = true
        } */
        form.maintenanceDate = [form.maintenanceDate, form.maintainEndDate]
        console.log(form)
        this.form = form;
        this.fileId = res.data.attachmentIds;
        this.form.subContractAmount = this.form.bsProject.subContractAmount
        this.OldFileList = deepClone(res.data.attachmentIds)
        this.tableData = res.data.laborCosts;
        this.tableData2 = res.data.chargeDetails;
        this.tableData3 = res.data.milestonePlans;
        this.tableData3.forEach(item => {
          item.keyOutsListArr = item.keyOutsList
          item.receipt = item.bizPaymentDetails
          })
        this.tableData5 = res.data.bonusPlans;
        this.tableData6 = res.data.bonuses;
        // 计算风险金比例
        // this.form.riskFundPercent = form.riskFundTotal !== null ? (form.riskFundTotal * 100 / form.targetCost).toFixed(2) + '%' : '未设风险金'
        /* if (form.contractDelivery == null) {
          this.form.costPercent = '未关联合同'
        } else {
          if (form.contractDelivery.totals > 0) {
            this.form.costPercent = form.contractDelivery.totals !== null && form.costBudgeting !== null ? (form.costBudgeting * 100 / form.contractDelivery.totals).toFixed(2) + '%' : '0%'
          } else {
            this.form.costPercent = '100%'
          }
        } */
      });
    } else {
      this.form.created = new Date()
      this.form.code = getDocumentCode("LXJF");
    }
    // 立项类型
    /* this.getDict("project_type").then(res => {
      this.formConfig.formItemList[this.formConfig.formItemList.findIndex(ele => ele.key === 'projectType')].options = res.data
    }); */

    // 调整类型
    this.getDict("change_type").then(res => {
      this.changeTypeStatus = res.data
      this.applyFormConfig.formItemList[this.applyFormConfig.formItemList.findIndex(ele => ele.key === 'changeType')].options = this.changeTypeStatus
    });

    // 款项说明
    /* this.getDict("RECEIPT").then(res => {
      this.receiptTypes = res.data;
      this.$set(this.tableHead3[this.tableHead3.findIndex(item => item.prop === 'receipt')].editRender,'options',this.receiptTypes)
    }); */
  },
  methods: {
    getInitFileState(form) {
      if (form.attrOrderId && ['2', '3'].includes(form.attrStatus + '')) {
        return true
      } else {
        return false
      }
    },
    getDeptTreeInterface() {
      // 开发部门
      getDeptAndChildrenTree(`${process.env.VUE_APP_TREEID}`).then(res => {
        const obj = this.formConfig.formItemList[this.formConfig.formItemList.findIndex(item => item.key === 'departmentId')]
        this.$set(obj,'options',res.data)
      });
    },
    dataTableBeforeInit () {
      this._url = "/projectMilestonePlanChange"
      const params = { page: this.page, size: this.offset }
      this._params = Object.assign(params, this._query)
      return true
    },
    releaseStatusFormatter(val) {
      switch (val) {
        case "01":
          return "占用中";
        case "02":
          return "借用中";
        case "03":
          return "释放中";
        case "04":
          return "已释放";
        default:
          return "";
      }
    },
    formatter(val) {
      if (val) {
        const date = new Date(val);
        return parseTime(date, "{y}-{m}-{d}");
      }
    },
    releaseDisposablePeople(row) {
      this.$router.push({
        path: "/bill/ReleaseResource/form",
        query: { id: row.id, isShow: false }
      });
    },
    /**
     *  根据两个时间的差计算出天数
     */
    getEndDate(date1,date2) {
      const date3 = this.$parseDate(date2).getTime() - this.$parseDate(date1).getTime() // 时间差的毫秒数
      // 计算出相差天数
      const days = Math.floor(date3 / (24 * 3600 * 1000))
      return days
    },
    // 开启阶段
    startMilestone(row) {
      deliveryMilestoneStatus(row.id,1).then(res => {
        if (res.code === 200) {
          this.doLayout = false
          this.$nextTick(() => {
            this.doLayout = true
            this.$nextTick(() => {
              row.isEnabled = 1
              this.$notify({ title: "操作成功", type: "success", duration: 2500})
              this.$refs[row.$index + 'a'].doClose()
              this.$refs.projectStage.doLayout()
            })
          })
        }
      })
    },
    // 变更历史表格
    changeApplyHis(row) {
      // TODO
      this.changeApplyHisVisible = true
      this._query = {milestonePlanId: row.id}
      this.dataTableInit()
      // var params = {
      //   page: 1,
      //   size: 10,
      //   milestonePlanId: row.id,
      // }
      // this.$nextTick(() => {
      //   getMilestonePlanChangePage(params).then(res => {
      //     if (res.code === 200) {
      //       console.log(res)
      //       this.applyHisList = res.data.records
      //     }
      //   })
      // })
    },
    // 打开变更申请
    changeApply(row) {
      this.changeApplyVisible = true
      // 设置弹出表单的内容
      this.applyForm = {
        milestonePlanId: row.id,
        projectId: this.form.id,
        projectNumber: this.form.projectNumber,
        projectName: this.form.projectName,
        milestoneName: row.bsMilestoneNode.name,
        expectedStartTime: row.expectedStartTime,
        latestFinishTime: row.latestFinishTime
      }
    },
    // 提交变更申请
    applyFormSubmit() {
      this.$confirm('确定提交申请吗?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          if (this.applyForm.changeStartTime) {
            var d = new Date(this.applyForm.changeStartTime);
            var datetimeStr = d.getFullYear() + '-' + (d.getMonth() + 1) + '-' + d.getDate() + ' ' + d.getHours() + ':' + d.getMinutes() + ':' + d.getSeconds();
            this.applyForm.changeStartTime = datetimeStr;
          }
          if (this.applyForm.changeFinishTime) {
            var endD = new Date(this.applyForm.changeFinishTime);
            var endDatetimeStr = endD.getFullYear() + '-' + (endD.getMonth() + 1) + '-' + endD.getDate() + ' ' + endD.getHours() + ':' + endD.getMinutes() + ':' + endD.getSeconds();
            this.applyForm.changeFinishTime = endDatetimeStr;
          }
          addMilestonePlanChange(this.applyForm).then(res => {
            if (res.code === 200) {
              this.$notify({ title: "提交成功", type: "success", duration: 2500})
              this.changeApplyVisible = false
            }
          })
        }).catch(() => {});
    },
    // 关闭阶段
    closeMilestone(row) {
      deliveryMilestoneStatus(row.id,2).then(res => {
        if (res.code === 200) {
          this.doLayout = false
          this.$nextTick(() => {
            this.doLayout = true
            this.$nextTick(() => {
              row.isEnabled = 2
              this.$notify({ title: "操作成功", type: "success", duration: 2500})
              this.$refs.projectStage.doLayout()
              this.$refs[row.$index + 'a'].doClose()
            })
          })
        }
      })
    },
    // 重置阶段
    resetMilestone(row) {
      deliveryMilestoneStatus(row.id,0).then(res => {
        if (res.code === 200) {
          this.doLayout = false
          this.$nextTick(() => {
            this.doLayout = true
            this.$nextTick(() => {
              row.isEnabled = 0
              this.$notify({ title: "操作成功", type: "success", duration: 2500})
              this.$refs.projectStage.doLayout()
              this.$refs[row.$index + 'a'].doClose()
            })
          })
        }
      })
    },
      // 项目阶段确认完成任务
    finishTask(row) {
      deliveryIsFinish(row.id,1).then(res => {
        if (res.code === 200) {
          row.isFinish = 1
          row.actualCompletionTime = parseTime(new Date(), "{y}-{m}-{d}")
          this.$notify({ title: "操作成功", type: "success", duration: 2500})
          this.$refs[row.$index + 'a'].doClose()
        }
      })
    },
    cancel() {
      this.$store.dispatch('tagsView/delView', this.$route)
      this.$router.go(-1);
    },
    // 上传成功
    handleSuccess (res) {
      if (res.code === 200) {
        this.$notify({ title: "上传成功！", type: "success", duration: 1500 });
        this.fileId.push(res.data);
      }
    },
    // 删除附件
    handleRemove (file, fileList) {
      delFile(file.id).then(res => {
        this.$notify({ title: "删除成功！", type: "success", duration: 1500 });
        this.fileId = fileList;
      });
    },
    // 删除附件之前
    beforeRemove (file, fileList) {
      return this.$confirm(`确定移除 ${file.name}？`);
    },
    preview (file) {
      downLoad(file.id, file.name);
    },
    // 保存
    save() {
      this.loading = true;
      this.update(this.getFormData())
    },
    /**
     * 导入模板确认
     */
    mbimport(val) {
      idQuery(val.id).then(res => {
        if (res.code === 200) {
          const arr = []
          res.data.bsProjectMilestonePlanList.forEach(ele => {
              const obj = {
                bsMilestoneNode: { name: ele.milestoneNodeName,id: ele.milestoneNode},
                workTargetDetail: ele.workTargetDetail,
                remark: ele.remark,
                keyOutsList: ele.keyOutsList,
                milestoneNode: ele.milestoneNode,
                keyOutput: ele.keyOutsList.map(ele => ele.id).join(",")
              }
              arr.push(obj)
          })
          this.tableData3 = arr
          this.importArr = []
        }
      })
    },
    close() {
       this.stepShow = false;
    },
    closeFile() {
      this.stepShowFile = false;
    },
    // 附件提交
    submitFile() {
      if (this.fileId.length === 0) {
        return this.$message.error("请提交预算详细清单给管理部门！")
      }
      if (this.OldFileList.length !== this.fileId.length) {
        return this.$message.error("请先保存该立项（交付）！")
      } else {
        const ids1 = this.OldFileList.map(item => item.id).join(',')
        const ids2 = this.fileId.map(item => item.id).join(',')
        if (ids1 !== ids2) {
          return this.$message.error("请先保存该立项（交付）！")
        }
      }
      this.loading = true
      getFlowNode({ from: "project_attr" }).then(res => {
      this.loading = false;
      this.personStepData = [];
      if (res.code === 200) {
        this.stepShowFile = true;
        this.personStepDataFile = res.data;
      } else {
        this.loading = false;
      }
    }).catch(() => {
      this.loading = false;
    });
      // if (this.) {}
      /* this.$confirm('请确认是否提交?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        submitFile({ projectDelivery: { id: this.form.id, attrStatus: '2' }, from: 'project_attr' }).then(res => {
          this.$notify({
            title: "操作成功",
            type: "success",
            duration: 2500
          });
          const { path } = this.$route
          this.$store.dispatch('tagsView/delCachedView', this.$route).then(() => {
            this.$router.replace({
              path: '/redirect' + path
            })
          })
        })
      }) */
    },
    // 提交
    submit() {
      if (!this.getFormData().attachmentIds || this.getFormData().attachmentIds.length === 0) {
        this.loading = false;
        return this.$message.error("请提交预算详细清单给管理部门！")
      }
      this._validateForm(this.validateRefNames).then((res) => {
        debugger
        // console.log('是否提交流程：', process.env.VUE_APP_IS_AUDIT)
        // if (process.env.VUE_APP_IS_AUDIT === 'no') { // 判断是否需要走审批
        //   this.$confirm('请确认是否提交?', '提示', {
        //     confirmButtonText: '确定',
        //     cancelButtonText: '取消',
        //     type: 'warning'
        //   }).then(() => {
        //     const obj = this.getFormData(2)
        //     obj.projectDelivery.billState = 3
        //     this.loading = true
        //     this.update(obj)
        //   }).catch(() => {
        //     this.loading = false
        //   });
        // } else {
          this.loading = true
          this.getFormData(2)
          getFlowNode({ from: "project_req", id: this.form.id }).then(res => {
            this.loading = false;
            this.personStepData = [];
            if (res.code === 200) {
              this.stepShow = true;
              this.personStepData = res.data;
            } else {
              this.loading = false;
            }
          }).catch(() => {
            this.loading = false;
          });
       // }
      }).catch(e => {
        this.loading = false;
      })
    },
    submitConfirm(val) {
      this.loading =  true
      const obj = this.getFormData(2)
      const obj2 = {}
      val.forEach(item => {
        let userList = "";
        item.assignData.forEach(ite => {
          userList = userList + (userList === "" ? ite.id : "," + ite.id);
        });
        obj2[item.key] = userList;
      });
      obj.assignData = JSON.stringify(obj2)
      this.update(obj)
    },
    submitConfirmFile(val) {
      const obj2 = {}
      val.forEach(item => {
        const userList = item.assignData.map(item => item.id).join(',')
        obj2[item.key] = userList;
      });
      this.$confirm('请确认是否提交?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.loading =  true
        submitFile({ projectDelivery: { id: this.form.id, attrStatus: '2' }, from: 'project_attr', assignData: JSON.stringify(obj2) }).then(res => {
          this.$notify({
            title: "操作成功",
            type: "success",
            duration: 2500
          });
          const { path } = this.$route
          this.$store.dispatch('tagsView/delCachedView', this.$route).then(() => {
            this.$router.replace({
              path: '/redirect' + path
            })
          })
        }).catch(() => {
          this.loading = false;
        }).finally(() => {
          console.log('12346')
          this.loading = false;
        })
      })
    },
    update(data) {
      const subData = deepClone(data)
      if (data.projectDelivery.maintenanceDate) {
        subData.projectDelivery.maintenanceDate = data.projectDelivery.maintenanceDate[0]
        subData.projectDelivery.maintainEndDate = data.projectDelivery.maintenanceDate[1]
      }
      addProjectDelivery(subData).then(res => {
          this.loading = false;
        if (res.code === 200) {
          this.$notify({
            title: "操作成功",
            type: "success",
            duration: 2500
          });
          if (data.projectDelivery.billState === 1) {
            if (this.form.id) {
              // 保存
              const { path } = this.$route
              this.$store.dispatch('tagsView/delCachedView', this.$route).then(() => {
                this.$router.replace({
                  path: '/redirect' + path
                })
              })
            } else {
              const {path} = this.$route
              this.$store.dispatch('tagsView/delView', this.$route).then(() => {
                this.$router.replace({path: '/redirect' + `${path}/1/${res.data}`})
              })
            }
          } else {
            this.cancel()
          }
        }
      }).finally(() => {
        this.loading = false;
      })
    },
    delLaborCosts(index) {
      if (this.tableData[index].id) {
        delLaborCosts(this.tableData[index].id);
        this.tableData.splice(index, 1);
      } else {
        this.tableData.splice(index, 1);
      }
    },
    delChargeDetails(id, scope) {
      if (id) {
        delChargeDetails(id).then(res => {
           this.$refs[scope.$index + 'b'].doClose()
            this.$notify({ title: "删除成功！", type: "success", duration: 1500 });
             this.tableData2.splice(scope.$index, 1);
        });
      } else {
       this.$refs.expense.deleteRows(scope.row)
       this.$refs[scope.$index + 'b'].doClose()
      }
    },
    delMilestonePlans(id, scope) {
      if (id) {
        delMilestonePlans(id).then(res => {
           this.$refs[scope.$index + 'a'].doClose()
            this.$notify({ title: "删除成功！", type: "success", duration: 1500 });
           this.tableData3.splice(scope.$index, 1);
        });
      } else {
        this.$refs.projectStage.deleteRows(scope.row)
        this.$refs[scope.$index + 'a'].doClose()
      }
    },
    delDisposablePeople(id, scope) {
      if (id) {
        delDisposablePeople(id).then(res => {
           this.$refs[scope.$index + 'c'].doClose()
          this.$notify({ title: "删除成功！", type: "success", duration: 1500 });
            this.tableData4.splice(scope.$index, 1);
        });
      } else {
        this.$refs.person.deleteRows(scope.row)
        this.$refs[scope.$index + 'c'].doClose()
      }
    },
    delBonusPlans(index) {
      if (this.tableData5[index].id) {
        delBonusPlans(this.tableData5[index].id);
        this.tableData5.splice(index, 1);
      } else {
        this.tableData5.splice(index, 1);
      }
    },
    delBonuses(index) {
      if (this.tableData6[index].id) {
        delBonuses(this.tableData6[index].id);
        this.tableData6.splice(index, 1);
      } else {
        this.tableData6.splice(index, 1);
      }
    },
    // 组装表单数据提交
    getFormData(status = 1) {  // 1保存 2提交
      try {
        if (this.form.projectObj) {
          // this.form.projectNumber = this.form.projectName.code;
          this.form.projectName = this.form.projectObj.name;
        }
        /* if (this.form.operatorObj) {
          this.form.operatorName = this.form.operatorObj.name;
          this.form.operator = this.form.operatorObj.id;
        } */
        if (this.form.projectManagerObj) {
          this.form.projectManagerName = this.form.projectManagerObj.name;
          this.form.projectManager = this.form.projectManagerObj.id;
        }
        if (this.form.contract) {
          const obj = {}
          obj.contractId = this.form.contract.id
          obj.projectCode = this.form.projectObj.code;
          obj.projectName = this.form.projectObj.name;
          obj.deliveryCode = this.form.code;
          obj.id = this.contractIds
          this.form.contractDelivery = obj
        } else {
          this.form.contractDelivery = { id: this.contractIds }
        }
        this.form.created = null
        this.form.billState = status;

        if (status === 2 && (!this.tableData3 || this.tableData3.length === 0)) {
          this.loading = false;
          return this.$notify({ title: "请先填写项目阶段", type: "warning", duration: 1500 });
        }
        for (const i of this.tableData3) {
          if (i.expectedStartTime > i.latestFinishTime) {
            this.loading = false;
            return this.$notify({ title: "项目阶段计划最晚完成时间不能小于预计开始时间！", type: "error", duration: 2500 });
          }
        }
        // if (status === 2 && this.fileId.length === 0) {
        //   // 如果没有上传附件
        //   this.loading = false;
        //   return this.$notify({ title: "请先上传附件", type: "warning", duration: 1500 });
        // }
        // 费用预算 + 人工目标成本不能大于交付成本！
        const total = this.$numberUtils.add(this.form.budget, this.form.targetCost, 0)
        if (total > this.form.costBudgeting) {
          this.loading = false;
          return this.$notify({ title: "费用预算加人工目标成本不能大于交付成本！", type: "error", duration: 2500 });
        }
        // 校验金额
        if (status === 2 && this.form.costForecast !== undefined && this.form.costForecast !== '' && this.tableData3) {
          const costForecastTemp = parseFloat(this.form.costForecast);
          let sumPlanCost = 0
          for (const i of this.tableData3) {
            sumPlanCost = this.$numberUtils.add(sumPlanCost, i.planCost, 2);
          }
          if (!this.$numberUtils.equals(costForecastTemp, sumPlanCost, 0.5)) {
            this.loading = false;
            return this.$notify({ title: "项目阶段预计消耗成本合计必须等于人工成本预算", type: "error", duration: 1500 });
          }
        }
        if (status === 2 && this.form.contract && this.form.contract !== '' && this.form.contract.totals > 0) {
          const contractTotal = parseFloat(this.form.contract.totals);
          let sumGain = 0.0
          for (const i of this.tableData3) {
            sumGain += parseFloat(i.gain);
          }
          if (contractTotal < sumGain) {
            this.loading = false;
            return this.$notify({ title: "项目阶段收入合计不能大于合同金额" + contractTotal, type: "error", duration: 1500 });
          }
        }
        if (status === 2 && this.tableData4.length <= 0) {
          this.loading = false;
          return this.$notify({ title: "可支配人员不能为空！", type: "error", duration: 2500 });
        }
        // 由于下面循环判断了重复人员，在此先做人员不能为空的判断
        for (let i = 0; i < this.tableData4.length; i++) {
          if (!this.tableData4[i].person) {
            this.loading = false;
            return this.$notify({ title: "可支配人员未填写完整！", type: "error", duration: 2500 });
          }
        }
        for (let i = 0; i < this.tableData4.length; i++) {
          for (let o = i + 1; o < this.tableData4.length; o++) {
            if (this.tableData4[i].person.id === this.tableData4[o].person.id && this.tableData4[i].projectRole === this.tableData4[o].projectRole) {
              this.loading = false;
              return this.$notify({ title: "可支配人员不能重复！", type: "error", duration: 2500 });
            }
          }
        }
        const obj = {};
        obj.status = status;
        obj.projectDelivery = this.form;
        if (status === 2) { // HR审批提交人信息
          obj.from = "project_req"
        }
        obj.laborCosts = this.tableData;
        obj.chargeDetails = this.tableData2;
        obj.milestonePlans = this.tableData3;
        obj.disposablePersonList = this.tableData4;
        for (const index of this.tableData4) {
          if (index.projectRole === null || index.projectRole === '') {
            this.loading = false;
            return this.$notify({ title: "存在项目角色为空的人员，请重新维护", type: "error", duration: 1500 });
          }
        }
        obj.bonusPlans = this.tableData5;
        obj.bonuses = this.tableData6;
        obj.attachmentIds = this.fileId;
        return obj
      } catch (e) {
        console.error(e, "getFormData出错了")
        this.loading = false
      }
    },

    summaryMethod(param) {
      const { columns, data } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = '合计';
          return;
        }
        if (['gain', 'planCost', 'actualCost', 'riskFund'].includes(column.property)) {
          const values = data.map(item => Number(item[column.property]));
          if (!values.every(value => isNaN(value))) {
            sums[index] = toThousandFilter(values.reduce((prev, curr) => {
              const value = Number(curr)
              if (!isNaN(value)) {
                return prev + curr
              } else {
                return prev
              }
            }, 0))
          } else {
            sums[index] = 'N/A'
          }
        } else {
          sums[index] = ''
        }
      })
      return sums
    }
  }
};
</script>

<style lang="scss" scoped>
.app-container {
  .box-card {
    background-color: #fff;
    padding: 20px 30px 20px 30px;
    border-radius: 10px;

    .content-title {
      height: 40px;
      background-color: #e7eff6;
      padding-left: 20px;
      overflow: hidden;

      .title-icon {
        display: inline-block;
        margin-top: 8px;
        width: 6px;
        height: 24px;
        background-color: #1369a8;
        margin-right: 14px;
      }

      .title-details {
        overflow: hidden;
        line-height: 20px;
        display: inline-block;
        font-size: 14px;
        color: rgba(51, 51, 51, 1);
        font-family: SourceHanSansSC-regular;
      }
    }

    .button {
      padding-top: 20px;
      text-align: right;

      .btn-submit {
        width: 80px;
        height: 38px;
        background: #1369a8;
        color: white;
      }
      .btn-submit-file {
        width: 100px;
      }

      .btn-cancel {
        width: 80px;
        height: 38px;
        background: #fff;
      }
      .isSubmit {
        background: rgba(19, 105, 168, 0.5);
      }
    }
  }
}
</style>
